/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { TournamentScheduleModel, TournamentScheduleModelType } from './TournamentScheduleModel'
import { TournamentScheduleModelSelector } from './TournamentScheduleModel.base'
import { RootStoreType } from './index'

/**
 * DayTournamentSchedulesBase
 * auto generated base class for the model DayTournamentSchedulesModel.
 */
export const DayTournamentSchedulesModelBase = ModelBase.named('DayTournamentSchedules')
  .props({
    __typename: types.optional(types.literal('DayTournamentSchedules'), 'DayTournamentSchedules'),
    schedules: types.union(types.undefined, types.array(types.late(() => TournamentScheduleModel)))
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class DayTournamentSchedulesModelSelector extends QueryBuilder {
  schedules(
    builder:
      | string
      | TournamentScheduleModelSelector
      | ((selector: TournamentScheduleModelSelector) => TournamentScheduleModelSelector)
      | undefined
  ) {
    return this.__child('schedules', TournamentScheduleModelSelector, builder)
  }
}
export function selectFromDayTournamentSchedules() {
  return new DayTournamentSchedulesModelSelector()
}

export const dayTournamentSchedulesModelPrimitives = selectFromDayTournamentSchedules()
